import React from 'react';
import formatCurrency from 'format-currency';
import Text from './Text';

type AmountProps = {
  amount: number;
  inCents: boolean;
};
export default function Amount({ amount, inCents, ...props }: AmountProps) {
  if (inCents) return <Text {...props}>{formatCurrency(amount / 100)}</Text>;
  return <Text {...props}>{formatCurrency(amount)}</Text>;
}
